module.exports = __webpack_public_path__ + "static/media/twIcon.01b8408b.png";